import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import type { ExtendedBuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { introDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { proLinks } from '@nodeTypeConfig/helpers/editComponents/proLinksAndMenuReferences';
import { proThumbnailComponent } from '@nodeTypeConfig/helpers/editComponents/proThumbnailComponent';
import { proWebFacetPlaceHolderComponent } from '@nodeTypeConfig/helpers/editComponents/proWebFacetComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import { proTileDefaultValidionRules } from '../proGenericConfigProps';
// Extends SECTION => A SECTION inside a Pro Theme and webConfig MINI_DATABASE_ITEM becomes a PRO_DATABASE_ITEM
const PRO_DATABASE_ITEM: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: proTileDefaultValidionRules,
  information: {
    definiteArticle: true,
    description: 'A Database Item, can only appear as child of a blog',
    single: 'Databank item',
    plural: 'Databank Items',
    icon: require('../../../../../img/icons/webpage.svg'),
  },

  ...extendsSection,
  isCollapsedByDefault: true,
  buildingBlocks: proDefaultBuildingBlocks,
  edit: [
    titleComponent,
    introDescriptionComponent,
    proThumbnailComponent,
    proLinks,
    proWebFacetPlaceHolderComponent,
  ],
  webTab: asideWebBasicConfiguration,
  confirmDelete: true,
};

export default PRO_DATABASE_ITEM;
